/**
 * Utility functions for haptic feedback and accessibility
 */

/**
 * Triggers haptic feedback for supported devices
 * @param duration - Duration in milliseconds (default: 50)
 */
export const triggerHapticFeedback = (duration: number = 50): void => {
  try {
    if ('vibrate' in navigator) {
      navigator.vibrate(duration);
    }
  } catch (error) {
    // Silently ignore haptics errors
  }
};

/**
 * Creates an accessible announcement for screen readers
 * @param message - The message to announce
 * @param timeout - How long to keep the announcement (default: 1000ms)
 */
export const announceToScreenReader = (message: string, timeout: number = 1000): void => {
  const announcement = document.createElement('div');
  announcement.setAttribute('role', 'alert');
  announcement.setAttribute('aria-live', 'polite');
  announcement.textContent = message;
  announcement.style.position = 'absolute';
  announcement.style.left = '-10000px';
  document.body.appendChild(announcement);
  
  setTimeout(() => {
    if (document.body.contains(announcement)) {
      document.body.removeChild(announcement);
    }
  }, timeout);
};

/**
 * Combined function for haptic feedback and screen reader announcement
 * @param message - The message to announce
 * @param hapticDuration - Duration of haptic feedback
 */
export const provideFeedback = (message: string, hapticDuration: number = 50): void => {
  triggerHapticFeedback(hapticDuration);
  announceToScreenReader(message);
};
